import React from 'react';
import Addresses from '../components/addresses';
function AddressesPage() {
    return <Addresses />;
}

export default AddressesPage;
